import { render, staticRenderFns } from "./PanelTop.vue?vue&type=template&id=3670a766&"
import script from "./PanelTop.vue?vue&type=script&lang=js&"
export * from "./PanelTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports